import styles from './ContentHeader.module.scss';

interface ContentHeaderProps {
    onMenuToggle: () => void;
}

export function ContentHeader({ onMenuToggle }: ContentHeaderProps) {
    return (
        <header className={styles.header}>
            <button className={styles.menuButton} onClick={onMenuToggle} aria-label="Toggle menu">
                <span className={styles.hamburger}>
                    <span></span>
                    <span></span>
                    <span></span>
                </span>
            </button>

            <div className={styles.searchContainer}>
                <span className={styles.searchIcon}>🔍</span>
                <input type="text" className={styles.searchInput} placeholder="Search assets..." />
            </div>

            <div className={styles.actions}>
                <button className={styles.iconButton} aria-label="Notifications">
                    🔔
                </button>
                <div className={styles.avatar}>
                    <span>B</span>
                </div>
            </div>
        </header>
    );
}
